<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="split"></section>
      <section slot="addressDetail">
        <ChooseAddressMap
          ref="sourceAddress"
          v-model="otherFormData"
          @cc="onChangeSource"
        />
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import ChooseAddressMap from 'components/chooseAddressMap/chooseAddressMap';
export default {
  components: {
    ChooseAddressMap,
  },
  data () {
    return {
      otherFormData: {
        address: '',
        lat: 0,
        lng: 0,
        provinceName: '',
        provinceId: 0,
        cityName: '',
        cityId: 0,
        districtName: '',
        districtId: 0,
      },
      baseForm: {
        inline: true,
        form: [
          {
            label: '地址名称',
            value: 'addressName',
            type: 'input',
          },
          {
            label: '',
            value: 'split',
            allCustom: true,
          },
          {
            label: '导航地址',
            value: 'addressDetail',
            slot: true,
          },
          {
            label: '应到地址',
            value: 'addressShow',
            type: 'input',
          },
        ],
        rules: {
          addressName: [
            { required: true, message: '请输入地址名称', trigger: 'blur' },
          ],
          addressDetail: [
            { required: true, message: '请输入导航地址', trigger: 'submit' },
          ],
          addressShow: [
            { required: true, message: '请输入应到地址', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    onChangeSource (data) {
      let addressDetail = '';
      let addressShow = data.address;
      const tempAddress = data.addressDetail;
      if (tempAddress.title) {
        addressShow += `（${tempAddress.title}）`;
      }
      if (tempAddress) {
        addressDetail = tempAddress.province + tempAddress.city + tempAddress.district + tempAddress.street + tempAddress.streetNumber;
      }
      this.otherFormData = {
        address: addressDetail || '',
        addressDetail: addressDetail || '',
        lat: data.lat ? Number(data.lat) : 0,
        lng: data.lng ? Number(data.lng) : 0,
        provinceName: data.provinceName || '',
        provinceId: data.provinceId,
        cityName: data.cityName || '',
        cityId: data.cityId,
        districtName: data.districtName || '',
        districtId: data.districtId,
      };
      this.$refs.baseForm.setVal('addressDetail', this.otherFormData.addressDetail);
      this.$refs.baseForm.setVal('addressShow', addressShow);
    },

    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        formData.lng = `${formData.lng}`;
        formData.lat = `${formData.lat}`;
        delete formData.address;
        formData.paramString = JSON.stringify(formData);
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    init (data = {}) {
      this.otherFormData = {
        address: data.addressDetail || '',
        addressDetail: data.addressDetail || '',
        lat: data.lat ? Number(data.lat) : 0,
        lng: data.lng ? Number(data.lng) : 0,
        provinceName: data.provinceName || '',
        provinceId: data.provinceId,
        cityName: data.cityName || '',
        cityId: data.cityId,
        districtName: data.districtName || '',
        districtId: data.districtId,
      };
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
